const angular = require('angular');
const app = angular.module('learn-services');

app.factory('NotificationService', ['Messaging', '$timeout', function(Messaging, $timeout) {
    var self = this;

    /**
     * Notification control object
     */
    self.notifications = {
      error: '',
      success: '',
      errorMessagesTTL: 5000,
      successMessagesTTL: 5000,
      notificationsTicker: 0,
      updateUserNotifications: function() {
        // Adds one to notificationsTicker triggering a watch to get the latest from the api (in the user notifications directive)
        self.notifications.notificationsTicker++;
      },
      getUserNotifications: function() {
        return self.notifications.notificationsTicker;
      },
      getError: function() {
        return self.notifications.error;
      },
      getSuccess: function() {
        return self.notifications.success;
      },
      setError: function(message, permanent) {
        Messaging.addMessage({type: 'error', text: message, duration: permanent ? 99999999 : 5});
        self.notifications.error = message;
        if (permanent !== undefined && permanent === true)
          return;
        $timeout(function() {
          self.notifications.clearError();
        }, self.notifications.errorMessagesTTL);
      },
      setSuccess: function(message, permanent) {
        Messaging.addMessage({type: 'success', text: message, duration: permanent ? 99999999 : 5});
        self.notifications.success = message;
        $timeout(function() {
          self.notifications.clearSuccess();
        }, self.notifications.successMessagesTTL);
      },
      clearError: function() {
        Messaging.clearMessages('error');
        self.notifications.error = '';
      },
      clearSuccess: function() {
        Messaging.clearMessages('success');
        self.notifications.success = '';
      }
    };
    return self.notifications;
  }]);